import { render, staticRenderFns } from "./UnloadingBaseEdit.vue?vue&type=template&id=2cf2e670&lang=pug"
import script from "./UnloadingBaseEdit.vue?vue&type=script&lang=js"
export * from "./UnloadingBaseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports